import { OnSchedUtils } from ".";

export const CustomEvents = (id, event, detail) => {
  const el = document.getElementById(id);
  const customEvent = new CustomEvent(event, { detail });
  
  el.dispatchEvent(customEvent);
}

export const GetEventType = (element, method) => {
  return method.toLowerCase() + element.type.slice(0,1).toUpperCase() + element.type.slice(1);
}

export const CalendarCustomEvents = {
  ViewChange: (e, element) => {
    const detail = {
      start: e.view.currentStart,
      end: e.view.currentEnd,
      view: Object.keys(OnSchedUtils.CalendarViews).find(k=>OnSchedUtils.CalendarViews[k]===e.view.type)
    }
    
    const elCalendar = document.getElementById(element.id);
    const calendarViewEvent = new CustomEvent("calendarViewChange", { detail });
    
    elCalendar.dispatchEvent(calendarViewEvent);
  },
  DateChange: (e, element) => {
    const elCalendar = document.getElementById(element.id);
    const changeDatesEvent = new CustomEvent("calendarDateChange", { detail: e });
    
    elCalendar.dispatchEvent(changeDatesEvent);
  },
  EventsLoaded: (element, arr, info) => {
    const events = arr.map(e => {
      e.calendar = OnSchedUtils.CalendarReasonCodes[e.extendedProps.reasonCode].calendar;
      return e;
    })
    const calendarEventsDetail = { detail: { events, date: info } };
    const calendarEventsCustomEvent = new CustomEvent("calendarEvents", calendarEventsDetail);
    const elCalendar = document.getElementById(element.id);
    
    elCalendar.dispatchEvent(calendarEventsCustomEvent);
  },
  CreateAppointment: (element, e) => {
    const elCalendar = document.getElementById(element.id);
        
    const appointmentObject = {
      locationId: element.params.locationId ? element.params.locationId : '',
      resourceId: e.resource?._resource?.id ? e.resource._resource.id : '',
      startDateTime: e.dateStr,
      date: e.date,
    }

    elCalendar.dispatchEvent(new CustomEvent("createAppointment", { detail: appointmentObject }))
  },
  SelectAppointment: (element, appointmentResp) => {
    const elCalendar = document.getElementById(element.id);

    elCalendar.dispatchEvent(new CustomEvent("selectAppointment", { detail: appointmentResp }));
  }
}
